/**
 * @fileoverview POST handler for the
 * "/companies/:company_id/email_self_serve/:app_group_id/sending_domain/:domain_id/assign_existing_tracking_domain"
 * endpoint. Assigns an existing tracking domain (owned by another sending domain in the same IP
 * pool) to the target sending domain by moving its configuration set.
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdEmailSelfServeSendingDomainDomainIdAssignExistingTrackingDomainCacheKeys } from "./constants";
import type { PostAssignExistingTrackingDomainProps, PostAssignExistingTrackingDomainResult } from "./types";

export const postAssignExistingTrackingDomain = reactQueryMutationAdapter(
  companiesCompanyIdEmailSelfServeSendingDomainDomainIdAssignExistingTrackingDomainCacheKeys,
  (props: PostAssignExistingTrackingDomainProps): Promise<PostAssignExistingTrackingDomainResult> => {
    const { companyId, appGroupId, domainId, parentSendingDomainId } = props;

    return fetch(
      `/companies/${companyId}/email_self_serve/${appGroupId}/sending_domain/${domainId}/assign_existing_tracking_domain`,
      "POST",
      { parent_sending_domain_id: parentSendingDomainId },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
